import { Attribute } from '../types'

export const checkIfRequired = (fieldConfig: Attribute): boolean => {
  return fieldConfig['is_required'] === true
}
